exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".config-container {\n  border: 1px solid grey;\n  border-radius: 3px; }\n  .config-container .content-container {\n    padding: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/ConfigPanel/ConfigPanel.scss
// module id = 863
// module chunks = 0